import { useQuery } from '@tanstack/react-query';

import { lookupsApi } from '@/api/lookupsApi';

export const lookupKeys = {
  all: ['lookups'] as const,
  geos: ['lookups', 'geos'] as const,
  sectors: ['lookups', 'sectors'] as const,
};

export function useGeos() {
  return useQuery({
    queryKey: lookupKeys.geos,
    queryFn: () => lookupsApi.getGeos(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useSectors() {
  return useQuery({
    queryKey: lookupKeys.sectors,
    queryFn: () => lookupsApi.getSectors(),
    staleTime: 5 * 60 * 1000,
  });
}
